import { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import OurLeaderShip from "../component/OurLeaderShip";
import { fetchAbout, fetchTeamLeaders } from "../../redux/action/moreAction";

const About = () => {
  const dispatch = useDispatch();
  const { isLoading1, teamLeadersList, aboutData } = useSelector(
    (state) => state.moreReducer
  );

  useEffect(() => {
    dispatch(fetchTeamLeaders());
    dispatch(fetchAbout());
  }, []);

  if (isLoading1) {
    return <Loader />;
  }

  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"About us"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          {
            name: "About us",
            path: `${pageRoutes?.home}/`,
          },
        ]}
        banner_image={aboutData?.about_banner}
      />
      <OurLeaderShip list={teamLeadersList} />
      {/* <Testimonials /> */}
      <Footer />
    </div>
  );
};

export default About;
